import React from 'react';

import EmptyProjectGraphic from '../../../public/static/svg/strategy-and-finance-icon.svg';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { Well } from '../../layout/Well/Well';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Grid } from '../../layout/Grid/Grid';
import { EmptyLayout } from '../../layout/EmptyLayout/EmptyLayout';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { IconButton } from '../../element/Button/IconButton';
import { Visible } from '../../layout/Visible/Visible';

import type { FocusAreaBarsFocusAreaType } from './focus-area-bars.types';
import { FocusAreaBarsRow } from './FocusAreaBarsRow';

const EMPTY_FOCUS_AREAS: FocusAreaBarsFocusAreaType[] = [];

export type FocusAreaBarsProps = {
  name?: string;
  title: string;
  subtitle?: React.ReactNode;
  focusAreas?: FocusAreaBarsFocusAreaType[];
  background?: 'light blue' | 'gray';
  onEditClick?: () => void;
  condensed?: boolean;
};

export const FocusAreaBars = ({
  name = 'FOCUS_AREA_BARS',
  title,
  subtitle,
  focusAreas = EMPTY_FOCUS_AREAS,
  background = 'light blue',
  onEditClick,
  condensed = false,
}: FocusAreaBarsProps) => {
  return (
    <Well background={background} name={name}>
      <Layout position="space-between">
        <LayoutItem>
          <ParagraphHeader name="TITLE">{title}</ParagraphHeader>
          {subtitle ? (
            <Gutter top="8px" name="SUBTITLE">
              {subtitle}
            </Gutter>
          ) : null}
        </LayoutItem>
        {onEditClick ? (
          <LayoutItem name="FOCUS_AREA_BARS_EDIT">
            <Gutter left="8px">
              <IconButton
                name="FOCUS_AREA_BARS_EDIT_BUTTON"
                icon="pencil"
                pattern="secondary"
                variation="minimal"
                onClick={() => {
                  onEditClick();
                }}
              />
            </Gutter>
          </LayoutItem>
        ) : null}
      </Layout>
      <Gutter bottom="16px" />
      {focusAreas.length > 0 ? (
        <Well background="light">
          <Grid>
            {focusAreas.map(fa => (
              <FocusAreaBarsRow
                key={fa.name}
                focusArea={fa}
                condensed={condensed}
              />
            ))}
          </Grid>
        </Well>
      ) : (
        <Well background="light" name="FOCUS_AREA_BARS_EMPTY">
          <EmptyLayout
            graphic={
              <Visible only="largeScreen">
                <EmptyProjectGraphic width="75px" height="78px" />
              </Visible>
            }
          >
            <ParagraphHeader>
              Top focus areas will appear here when you add focus areas to your
              profile experiences.
            </ParagraphHeader>
            <Gutter bottom="16px" />
            <Paragraph>
              Focus areas help clients better understand the depth and breadth
              of your experience.
            </Paragraph>
          </EmptyLayout>
        </Well>
      )}
    </Well>
  );
};
